export default "__VITE_ASSET__B9QY2XGR__"